<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- Empolyee Number -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">EMPLOYEE NUMBER :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeNumberError = ''" maxlength="190" class="form-control" v-model="employeeNumber" id="empolyee_name" placeholder="Enter Employee Number" name="employeeNumber" :disabled="$route.params.id ? true : false">
                                <div class="help is-danger">{{employeeNumberError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Empolyee Name -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">EMPLOYEE'S FULL NAME :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeNameError = ''" maxlength="190" class="form-control" v-model="employeeName" id="empolyee_name" placeholder="Enter Employee Name" name="employeeName" :disabled="$route.params.id ? true : false">
                                <div class="help is-danger">{{employeeNameError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>

                        <!-- Date -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">DATE :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <date-picker @input="dateError = ''" placeholder="DD/MM/YYYY" id="date_of_request" name="date" v-model="date" :config="options" aria-describedby="basic-addon1" :disabled="$route.params.id ? true : false"></date-picker>
                                <div class="help is-danger">{{dateError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Location -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">LOCATION :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="location" name="location"
                                    label="name" placeholder="Select Location"
                                    @input="location_error = ''"
                                    :options="location_arr" :clearable="false" :disabled="$route.params.id ? true : false">
                                </v-select>
                                <div class="help is-danger">{{location_error}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>

                        <!-- Empolyee Email -->
                        <div class="col-4 forms-block">
                            <div class="">
                                <div class="form-label">EMPLOYEE EMAIL ADDRESS :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="employeeEmailError = ''" maxlength="190" class="form-control" v-model="employeeEmail" id="employeeEmail" placeholder="Enter Employee Email" name="employeeEmail" :disabled="$route.params.id ? true : false">
                                <div class="help is-danger">{{employeeEmailError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>

                        <!-- Status -->
                        <div class="col-4 forms-block" v-show="status_field">
                            <div class="">
                                <div class="form-label">STATUS :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="status" name="status"
                                    label="name" placeholder="Select Status"
                                    :options="statusArr" :clearable=false>
                                </v-select>
                            </div>
                        </div>
                        
                        <div class="col-12 forms-block">
                            <div class="col-12 paddingleft0">
                                <div class="form-label block-title-tech-time">Shift Change Details</div>
                            </div>
                        </div>
                        <template>
                            <div class="col-md-12">
                                <!-- Start Date -->
                                <div class="col-4 forms-block">
                                    <div class="">
                                        <div class="form-label">START DATE :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="startDateError = ''" maxlength="190" class="form-control" v-model="startDate" id="start_date" placeholder="Enter Start Date" name="startDate" :disabled="$route.params.id ? true : false">
                                        <div class="help is-danger">{{startDateError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                
                                <!-- CURRENT TECHNICIAN SHIFT -->
                                <div class="col-4 forms-block">
                                    <div class="">
                                        <div class="form-label">CURRENT TECHNICIAN SHIFT :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="currentShiftError = ''" maxlength="190" class="form-control" v-model="currentShift" id="current_shift" placeholder="Enter Current Shift" name="currentShift" :disabled="$route.params.id ? true : false">
                                        <div class="help is-danger">{{currentShiftError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- TECHNICIAN SHIFT CHANGE -->
                                <div class="col-4 forms-block">
                                    <div class="">
                                        <div class="form-label">TECHNICIAN SHIFT CHANGE :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" @input="shiftChangeError = ''" maxlength="190" class="form-control" v-model="shiftChange" id="shift_change" placeholder="Enter Change Shift" name="shiftChange" :disabled="$route.params.id ? true : false">
                                        <div class="help is-danger">{{shiftChangeError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                
                                <!-- DURATION -->
                                <div class="col-4 forms-block">
                                    <div class="">
                                        <div class="form-label">DURATION :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" maxlength="190" class="form-control" v-model="duration" id="duration" placeholder="Enter Duration" name="duration" :disabled="$route.params.id ? true : false">
                                    </div>
                                </div>

                                <!-- END DATE (IF NOT ONGOING) -->
                                <div class="col-4 forms-block">
                                    <div class="">
                                        <div class="form-label">END DATE (IF NOT ONGOING) :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" maxlength="190" class="form-control" v-model="end_date" id="end_date" placeholder="Enter End Date" name="end_date" :disabled="$route.params.id ? true : false">
                                    </div>
                                </div>

                                <!-- COMMENTS -->
                                <div class="col-4 forms-block">
                                    <div class="">
                                        <div class="form-label">COMMENTS :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input type="text" class="form-control" v-model="comments" id="comments" placeholder="Enter Comment" name="comments" :disabled="$route.params.id ? true : false">
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUpdateTechTimeSHiftChange('save')"><span id="createAttachment">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
import { hide } from 'cli-cursor';
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'addUpdateTechTimeSHiftChange',
        props: [''],
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Technician Shift Change',
                edit_id: 0,
                employeeNumber: "",
                employeeNumberError: "",
                employeeName: "",
                employeeNameError: "",
                date: new Date(),
                dateError: "",
                options: {
                    format: 'DD/MM/YYYY',
                },
                optionsTime: {
                    format: 'hh:mm A',
                },
                location: "",
                location_arr: [],
                location_error: "",
                statusArr: [],
                status: "",
                employeeEmail: "",
                status_field: false,
                employeeEmailError: "",
                startDate: "",
                startDateError: "",
                currentShift: "",
                currentShiftError: "",
                shiftChange: "",
                shiftChangeError: "",
                duration: "",
                end_date: "",
                comments: "",
                managerEmail: "",
                loginUserRoleId: 1,
            }
        },
        watch: {
            location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("TechicianShiftChangeForm");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            self.loadTechShiftData();
            // self.loadLocation();
            // self.loadBodyShopLocation();
            self.loadLocationFromZone();
        },
        methods: {
            buttonBack() {
                self.$router.push('/technician/shift/list');
            },
            changedValue: function (department) {
                self.departmentIdError = "";
                self.location_arr = [];
                self.location = "";
                if (department != 'undefined' && department.value) {
                    self.location_arr = self.serviceLocationArr;
                    if(department.value == 'Body Shop') {
                        self.location_arr = self.bodyShopLocationArr;
                    }
                }
            },
            loadBodyShopLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 8
                    }
                };
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                    .then(function (response) {
                        self.bodyShopLocationArr = response.data.locations;
                        if(self.bodyShopLocationArr && self.bodyShopLocationArr.length > 0) {
                            /* for(var index = 0; index < self.bodyShopLocationArr.length; index++) {
                                var objLocation = self.bodyShopLocationArr[index];
                                if(objLocation['name'] == 'Hope Mills Bodyshop, NC' || objLocation['id'] == 76) {
                                    self.bodyShopLocationArr.splice(index, 1);
                                }
                            } */
                            self.bodyShopLocationArr = self.bodyShopLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        }
                        // console.log(JSON.stringify(self.bodyShopLocationArr));
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 2
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                        .then(function (response) {
                            self.location_arr = response.data.locations;
                            // self.serviceLocationArr = response.data.locations;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            loadLocationFromZone() {
                var config = {
                    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
                    params: {
                        id: self.edit_id
                    }
                };
                self.showLoader();
                HTTP.get("/get/locations", config)
                    .then(function (response) {
                        self.location_arr = response.data.content;
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () { });
                    });
            },
            loadTechShiftData: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")}
                };
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    var userJson = JSON.parse(userObj);
                    self.loginId = userJson.id;
                }
                if (segments[1] == 'updateshift') {
                    var fields = {id: segments[2]};
                }
                HTTP.post('getshift/' + segments[2], fields, config)
                        .then(function (response) {
                            if(response.data.content.length > 0) {
                                // Show The Status While Edit
                                self.status_field = true;
                                self.employeeNumber = response.data.content[0].employee_number;
                                self.employeeName = response.data.content[0].employee_name;
                                self.date = response.data.content[0].date;
                                self.employeeEmail = response.data.content[0].employee_email.trim();
                                self.startDate = response.data.content[0].start_date;
                                self.currentShift = response.data.content[0].current_shift;
                                self.shiftChange = response.data.content[0].shift_change;
                                self.duration = response.data.content[0].duration;
                                self.end_date = response.data.content[0].end_date;
                                self.comments = response.data.content[0].comments;
                                self.status = {name: response.data.content[0].status, id: response.data.content[0].status};
                                if(response.data.content[0].status == 'In Progress') {
                                    self.statusArr = [{
                                                        name: 'In Progress',
                                                        value: 'In Progress',
                                                    },
                                                    {
                                                        name: 'Completed',
                                                        value: 'Completed',
                                                    }];
                                }else{
                                    self.statusArr = [{
                                                        name: 'Completed',
                                                        value: 'Completed',
                                                    },
                                                    {
                                                        name: 'In Progress',
                                                        value: 'In Progress',
                                                    }
                                                    ];
                                }
                                self.location = {name: response.data.content[0].employee_location, id: response.data.content[0].employee_location};
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                            if (err.response.status == 0) {
                                self.error = "No Data Found.";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            checkForm: function () {
                var checked = true;
                var todayDate = moment().format("MM/DD/YYYY");
                self.employeeNumberError = "";
                self.employeeNameError = "";
                self.dateError = "";
                self.employeeEmailError = "";
                self.location_error = "";
                self.startDateError = "";
                self.currentShiftError = "";
                self.shiftChangeError = "";

                if (!self.employeeNumber) {
                    self.employeeNumberError = "Please enter employee number";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeName) {
                    self.employeeNameError = "Please enter employee name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date) {
                    self.dateError = "Select Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.location == null || !self.location.id) {
                    self.location_error = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeEmail) {
                    self.employeeEmailError = "employee Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.employeeEmail && !self.validEmail(self.employeeEmail)) {
                    self.employeeEmailError = "Please Enter Valid employee Email";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.startDate) {
                    self.startDateError = "Please enter start date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.currentShift) {
                    self.currentShiftError = "Please enter current shift";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.shiftChange) {
                    self.shiftChangeError = "Please enter shift change";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },
            addUpdateTechTimeSHiftChange(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        if (segments[1] == 'updateshift') {
                            self.id = segments[2];
                        }
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            id: self.id,
                            manager_email: self.managerEmail,
                            empolyee_number: self.employeeNumber,
                            date: self.date,
                            empolyee_name: self.employeeName,
                            location_id: self.location.id,
                            location: self.location.name,
                            employee_email: self.employeeEmail,
                            startDate: self.startDate,
                            currentShift: self.currentShift,
                            shiftChange: self.shiftChange,
                            duration: self.duration,
                            end_date: self.end_date,
                            comments: self.comments,
                            status: self.status.value,
                        };
                        self.showLoader();
                        HTTP.post("/techshiftchange/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                        self.buttonBack();
                                    } else {
                                        self.departmentId = '';
                                        self.employeeNumber = '';
                                        self.date = '';
                                        self.employeeName = '';
                                        self.location = '';
                                        self.employeeEmail = '';
                                        self.managerEmail = '';
                                        self.startDate = '';
                                        self.currentShift = '';
                                        self.shiftChange = '';
                                        self.duration = '';
                                        self.end_date = '';
                                        self.comments = '';
                                        self.status = '';
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>
<style scoped>
    .block-title-tech-time {
        float: left;
        width: 100%;
        margin: 0 0 15px 0;
        padding: 0;
        font-weight: normal;
        font-size: 28px;
        color: #0f467c;
        font-family: 'SanFranciscoDisplay-Bold';
    }
</style>


// WEBPACK FOOTER //
// src/components/Forms/TechicianShiftChangeMaster/AddUpdateTechicianShiftChange.vue